import { render } from "./DoctorProfilePage.vue?vue&type=template&id=621942d1&scoped=true&ts=true"
import script from "./DoctorProfilePage.vue?vue&type=script&lang=ts"
export * from "./DoctorProfilePage.vue?vue&type=script&lang=ts"

import "./DoctorProfilePage.vue?vue&type=style&index=0&id=621942d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621942d1"]])

export default __exports__